import React, { useState, useContext } from 'react';
import './css/SignIn.css';
import { useNavigate } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import { Context } from '../../services/apiContext';
import useAuth from '../../services/authContext';
import configData from '../../utils/config/config.json';
import { useGlobalSpinnerActionsContext } from '../../components/loader/useloader';
import { useNotificationActionsContext } from '../../components/notificationModal/useModal';
import { sha512 } from 'js-sha512';
import cryptoRandomString from 'crypto-random-string';
import { getClientIp } from '../../helperFunctions/helperFunctions';
const OTP_signIn = (props) => {
  const contextapi = useContext(Context);
  const navigate = useNavigate();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const setNotifi = useNotificationActionsContext();
  const [otpResponse, setOtpResponse] = useState({});
  const [otpValue, setOtpValue] = useState('');
  const [errOTP, setOTPErr] = useState('');
  const [otpCountDown, setOTPCountDown] = useState(180);
  const [otpAttemptCount, setOTPAttemptCount] = useState(3);
  const [otpResendCount, setOTPResendCount] = useState(5);
  const { login, loginReferrer } = useAuth();

  React.useEffect(() => {
    let myInterval = setInterval(() => {
      if (otpCountDown > 0) {
        setOTPCountDown(otpCountDown - 1);
      } else {
        clearInterval(myInterval);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [otpCountDown]);

  const handleChange = (otp) => {
    setOtpValue(otp);
  };

  const validateOTP = () => {
    if (otpAttemptCount === 0) {
      setNotifi({
        val: true,
        msg: 'OTP attempt exceeded. Please try again after sometime',
      });
    } else if (otpCountDown === 0) {
      setNotifi({
        val: true,
        msg: 'OTP expired. Please click on resend to generate new OTP',
      });
    } else if (otpValue.length === 4) {
      setOTPErr('');
      verifyOTP();
    } else {
      setOTPErr('Please enter all digits');
    }
  };

  const verifyOTP = async () => {
    setGlobalSpinner(true);
    var hashedOTP = sha512(otpValue).toLocaleLowerCase();
    const salt = cryptoRandomString({ length: 8 }).toLocaleLowerCase();
    hashedOTP = sha512(hashedOTP + salt).toLocaleLowerCase();
    var url = '/user/verifymobileotp';
    var postobjt = {
      mobile: props.data.mobile,
      otp: hashedOTP,
      salt: salt,
      user_ip: await getClientIp(),
      validation_key: props.data.validation_key,
      grant_type: 'password',
    };

    var prms = new URLSearchParams(postobjt);
    var prmsNew = prms.toString();
    console.log(postobjt);
    await contextapi
      .postApiCalling(url, prmsNew)
      .then((res) => {
        // console.log(res);
        if (res.access_token) {
          setOtpResponse(res);
          setGlobalSpinner(false);
          if (props.gotoRefer) {
            loginReferrer().then(() => {
              contextapi.setSession(res, 'userData_refer');
              contextapi.setSession(res.access_token, 'access_token_refer');
              navigate('/refer');
            });
          } else {
            login().then(() => {
              contextapi.setSession(res, 'userData');
              contextapi.setSession(res.access_token, 'access_token');
              checkUserStatus(res);
            });
          }
        } else {
          setOTPAttemptCount(otpAttemptCount > 0 ? otpAttemptCount - 1 : 0);
          if (otpAttemptCount > 1) {
            setNotifi({ val: true, msg: 'Invalid OTP. Please try again' });
          } else {
            setNotifi({
              val: true,
              msg: 'You have exceeded the number of OTP attempts, we are re-sending the OTP on your registered mobile number',
            });
            resendOTP();
          }
          setOtpValue('');
        }
      })
      .catch((error) => {
        console.log('Error VerifyOTP: ', error);
        setGlobalSpinner(false);
        // setNotifi({ val: true, msg: "Something went wrong" });
        setOtpResponse({ val: true, msg: 'Something went wrong' });
      });
  };

  const checkUserStatus = async (res) => {
    setGlobalSpinner(true);
    var url = configData.baseURLProxy;
    var postobjt = {
      data: {
        user_ip: await getClientIp(),
        user_key: res.user_key,
      },
      url: configData.baseURLDev + '/user/profilestatus',
    };
    await contextapi
      .postApiAuthCalling(url, postobjt, false)
      .then((res) => {
        console.log(res);
        setGlobalSpinner(false);
        if (res.data.status_code === '00') {
          var userData = res.data;

          contextapi.setSession(userData, 'userProfile');
          contextapi.setSession(props.refId, 'userRefId');
          navigate(
            userData.bank_details === 'Y' &&
              userData.basic_profile === 'Y' &&
              userData.dp_details === 'Y'
              ? '/home/dashboard'
              : props.refId
              ? '/UserProfile?refid=' + props.refId
              : '/UserProfile'
          );
        } else {
          setNotifi({ val: true, msg: res.reponse[0].status_desc });
        }
      })
      .catch((error) => {
        console.log(error);
        setGlobalSpinner(false);
        // setNotifi({ val: true, msg: "Somthing went wrong" });
      });
  };
  const resendOTP = async () => {
    var useData = contextapi.getSession('userData').user_key;
    console.log(otpResponse);
    setGlobalSpinner(true);
    var url = '/user/resendotp';
    var postobjt = {
      validation_refno: props.data.validation_key,
      validation_type: props.data.validation_type,
      user_ip: await getClientIp(),
      user_key: otpResponse.user_key ? otpResponse.user_key : '',
    };
    await contextapi
      .postApiCalling(url, postobjt)
      .then((res) => {
        // console.log(res.response[0]);
        setGlobalSpinner(false);
        if (res.response[0].status_code === '00') {
          setOtpValue('');
          setOTPResendCount(otpResendCount - 1);
          setOTPAttemptCount(3);

          setOTPCountDown(180);
          setOtpResponse(res.response[0]);
          setNotifi({
            val: true,
            msg: 'OTP has been Resent Successfully to your Mobile Number',
          });
        } else {
          setNotifi({ val: true, msg: res.response[0].status_desc });
        }
      })
      .catch((error) => {
        console.log(error);
        setGlobalSpinner(false);
        // setNotifi({ val: true, msg: "Somthing went wrong" });
        setOtpResponse({ val: true, msg: 'Somthing went wrong' });
      });
  };

  return (
    <div id='signin' className='container tab-pane active p-0'>
      <div className='row'>
        <div className='col-md-12 '>
          <div className='otp-box-cntnt'>
            <h1 className='mb-4'>
              <span className='headh1'>Enter OTP</span>
            </h1>
            <p className='mb-4'>
              Please enter the 4-digit verification code received on your
              registered mobile
            </p>
            <div className='enter-otp-hdng'>
              <p>
                Enter Your OTP <span className='txt-red'>*</span>
              </p>
              <span className='fontweight300 remaining-attempts-txt'>
                OTP will expire in: <b>{otpCountDown} seconds</b>
              </span>
            </div>
            <div className='row gx-3'>
              {/* <div className="form-group col-3">
                                <input type="text" className="form-control text-center" id="otp1" placeholder="2" />
                            </div>
                            <div className="form-group col-3">
                                <input type="text" className="form-control text-center" id="otp2" placeholder="2" />
                            </div>
                            <div className="form-group col-3">
                                <input type="text" className="form-control text-center" id="otp3" placeholder="2" />
                            </div>
                            <div className="form-group col-3">
                                <input type="text" className="form-control text-center" id="otp4" placeholder="2" />
                            </div> */}
              <div className='form-group '>
                <OtpInput
                  value={otpValue}
                  onChange={handleChange}
                  numInputs={4}
                  separator={<span> </span>}
                  inputStyle={{
                    width: '90%',
                    height: '150%',
                    color: 'rgb(0,82,156)',
                    fontWeight: 'bold',
                  }}
                  isInputSecure={true}
                  isInputNum={true}
                  shouldAutoFocus={true}
                  className='mt-3 custommakeinputcss'
                />
              </div>
              {errOTP !== '' ? (
                <span className='text-danger'>
                  <i
                    className='pe-2 fa fa-exclamation-circle'
                    aria-hidden='true'
                  ></i>
                  {errOTP}
                </span>
              ) : null}
            </div>
            <div className='form-group mb-3'>
              {/* <button
                type="submit"
                className="btn btn-default form-control colorwhite"
                disabled={otpAttemptCount === 0 || otpCountDown === 0}
                onClick={validateOTP}
              > */}
              <button
                type='submit'
                className='makewhitcolor btnInuse btn-default makewhitcolor maekitfullwidth'
                disabled={otpAttemptCount === 0 || otpCountDown === 0}
                onClick={validateOTP}
              >
                Verify OTP
              </button>
            </div>
            <div className='form-group text-left resend-code-box'>
              {otpResendCount > 0 ? (
                <p className='fontweight300 mb-0'>
                  Didn't get the code?{' '}
                  <a className='fontweight400' onClick={resendOTP}>
                    Resend
                  </a>
                </p>
              ) : (
                <p className='fontweight300 mb-0'>
                  All resend attempts have been utilised
                </p>
              )}
              <span>
                Remaining Attempts: <b>{otpAttemptCount}</b>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTP_signIn;
